import * as jose from 'jose';

const KEY = 'userData';

const DEFAULT_USER = { UserId: 0 };

export const getLoggedInUser = () => {
  const value = localStorage.getItem(KEY) || '{"Token":""}';
  const user = JSON.parse(value);
  try {
    return jose.decodeJwt(user.Token);
  } catch (e) {
    return DEFAULT_USER;
  }
};
